import { createAsyncReducer } from '@telstra-connect/standard-actions';
import {
    ILoadFeaturePackDetailAction,
    ILoadFeaturePackDetailSuccessAction,
    FeaturePackDetailErrorAction
} from '../actions/load-feature-pack-details';
import { IBillingState } from '../state';
import { initialState } from '../state/initial-state';

export type LoadFeaturePackDetailAction
    = ILoadFeaturePackDetailAction
    | ILoadFeaturePackDetailSuccessAction
    | FeaturePackDetailErrorAction;

const init = (state: IBillingState, action: LoadFeaturePackDetailAction) => ({
    ...state,
    featurePackDetail: {
        ...state.featurePackDetail,
        status: action.status
    }
});

const success = (state: IBillingState, action: LoadFeaturePackDetailAction) => ({
    ...state,
    featurePackDetail: {
        status: action.status,
        data: (action as ILoadFeaturePackDetailSuccessAction).data
    }
});

const failure = (state: IBillingState, action: LoadFeaturePackDetailAction) => ({
    ...state,
    featurePackDetail: {
        ...initialState.featurePackDetail,
        status: action.status,
        error: (action as FeaturePackDetailErrorAction).error,
        errorCode: (action as FeaturePackDetailErrorAction).errorCode
    }
});

export const loadFeaturePackDetailReducer = createAsyncReducer(initialState, init, success, failure);
